// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1IJYh","gfeWrapper":"CalendarEvent_gfeWrapper__xzoJ7"};